export default "__VITE_ASSET__802a05d0__"